import { useMutation } from '@tanstack/react-query';

import { ErrorResponse } from '@shared/api';

import { RedeemAwardCode } from './api';
import { TRedeemRewardResponse } from './types';

export const useRedeemReward = () =>
  useMutation<TRedeemRewardResponse, ErrorResponse, string>({
    mutationFn: (code) => RedeemAwardCode(code),
  });
